<template>
  <div>
    <Header title="成绩认定" type="0" route="/student/score_Affirmation"></Header>
    <div class="score_replace">
      <!-- <div class="score_replace_course">
        <h4>{{this.topInfo.COURSENAME}}</h4>
        <p>课程代码：{{this.topInfo.COURSECODE}}</p>
        <p>学分：{{this.topInfo.CREDIT}}</p>
        <p>属性：{{this.topInfo.COURSEATTRIBUTE}}</p>
      </div> -->
      <h3 style="color: @attendance-background-color-1;font-size: 18px;">请选择替代课程<small>（可多选）</small></h3>
      <div class="course_list" v-for="(item,index) in courseList" :key="index" @click="canSelect(item.CANCHECK)">
        <div>
          <h4>{{item.COURSENAME}}</h4>
          <p class="course_list_item">课程代码:{{item.COURSECODE}}</p>
          <div class="course_list_item">
            <span>学分: <small>{{item.CREDIT}}</small></span>
            <span>属性: <small>{{item.COURSEATTRIBUTE}}</small></span>
            <span v-if="schoolCode == '12763'">学期: <small>{{item.KKXQ}}</small></span>
          </div>
        </div>
        <el-checkbox v-model="item.checked" v-if="item.CANCHECK == 1"></el-checkbox>
      </div>
    </div>
    <div class="submit_btn">
      <button @click="courseSubmit()">下一步</button>
    </div>

    <van-popup v-model="show" class="popup">
        <span @click="ggtzclose" class="close" >
          <van-icon  name="cross" size="18" color="#C8C9CC" />
        </span>
          <van-form @submit="submitFjRd">
            <van-field
              :required="sffjbt == '1'"
              name="uploader"
              label="上传附件"
              input-align="right"
            >
              <template #input>
                <van-uploader
                  accept=".pdf,.png,.jpg"
                  :max-count="5"
                  v-model="fileList"
                />
              </template>
            </van-field>
            <div class="qz-button-group">
              <template >
                <button class="thsxxztxBtn" native-type="submit">保存</button>
              </template>
            </div>
          </van-form>
    </van-popup>
  </div>
</template>

<script>
  import { Api } from '../../../utils/axios'
  export default {
    data(){
      return{
        topInfo:'',
        valueList:'',
        courseList:[],
        schoolCode : sessionStorage.getItem("schoolCode"),
        show:false,
        fileList: [],
        sffjbt:''
      }
    },
    created(){
      this.topInfo = this.$route.query.data;
      this.getList()
    },
    methods:{
      async getList(){
        const res = await Api.alterNativeCourses()
        this.courseList = res.data;
        if(this.schoolCode = '12763'){
          this.sffjbt = res.sffjbt;
        }
        if(res.data.length == 0){
          this.$toast(res.Msg);
        }
      },
      async submit(){
        let shrparams = {
          ywcode: "011"
        };
        let userid = ''
        const shrres = await Api.selectReviewerApi(shrparams);
        let idList = [];
        shrres.data.forEach(item => {
          idList = idList.concat(item.userid);
        });
        userid = idList.toString();

        const params = {
          cj0708ids:this.topInfo,
          jx02kczkcids:this.valueList,
          userid: userid
        }
        let formData = new FormData();
        Object.keys(params).forEach(key => {
          formData.append(key, params[key]);
        });
        if(this.schoolCode = '12763'){
          // 附件
          this.fileList.forEach(file => {
            formData.append("file", file.file);
          });
        }
        const res = await Api.alterNativeCoursesSave(formData)
        if(res.code == '1'){
          this.$router.push({ path:'/student/submit_success', query: {'msg':res.Msg}})
        }else{
          this.$toast(res.Msg)
        }
      },
      canSelect(val){
        if(val == '0'){
          this.$toast.fail('当前课程不可选')
        }
      },
      courseSubmit(){
        if(this.schoolCode = '12763'){
          //弹窗上传附件
          this.show = true
        }else{
          this.submitRd()
        }
      },
      ggtzclose(){
        this.show = false
      },
      submitFjRd(){
        //必填时第一个附件必填
        console.log(this.fileList)
        if((this.fileList == null || this.fileList.length == 0) && this.sffjbt =='1'){
          this.$toast.fail('附件为空')
          return;
        }
        this.submitRd()
      },
      submitRd(){
        for(let i = 0;i < this.courseList.length;i++){
          if(this.courseList[i].checked){
            this.valueList +=  this.courseList[i].JX02KCZKCID + ',';
          }
        }
        this.valueList = this.valueList.substring(0,this.valueList.length-1);
        if(this.valueList !== ''){
          this.submit()
        }else{
          this.$toast.fail('至少选择一门课程')
        }
      }
    }

  }
</script>

<style lang="less" scoped>
  .score_replace{
    padding:10px 20px;
    box-sizing: border-box;
    overflow: auto;
    margin-bottom: 70px;
  }
  .score_replace .score_replace_course{
    margin-bottom: 30px;
  }
  .score_replace .score_replace_course>h4{
    color: @attendance-color-1;
    font-size: 18px;
    line-height: 30px;
  }
  .score_replace .score_replace_course>p{
    color: @attendance-color-2 ;
    font-size: 14px;
    height: 25px;
    line-height: 25px;
  }
  .score_replace .course_list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: @attendance-background-color-10;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0 20px;
    margin-top: 20px;
    height: 82px;
  }
  .score_replace .course_list .course_list_item{
    color: @attendance-color-2 ;
    font-size: 12px;
    line-height: 17px;
  }
  .score_replace .course_list h4{color: @attendance-color-1;font-size: 16px;line-height:22px;margin-bottom:4px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
  .score_replace .course_list p{margin-bottom: 2px;}
  .score_replace .course_list .course_list_item small{
    color: red;
    font-size: 10px;
  }
  .score_replace .course_list .course_list_item span{
    margin-right: 25px;
  }
  .score_replace .el-checkbox__inner{
    width: 18px;
    height: 18px;
    border-radius: 50%;
  }
  .score_replace .el-checkbox__inner::after{
    left: 6px;
    top: 3px;
  }
  .score_replace .el-checkbox__input.is-checked .el-checkbox__inner{
    background: @attendance-background-color-1;
    border-color:@attendance-background-color-1;
  }
  .submit_btn button{background: @attendance-background-color-1;height:44px;color: @attendance-color-3;border-radius:3px;margin: 10px 20px 20px;}
  .submit_btn{text-align: center;position: fixed;bottom: 0px;z-index: 99;width: 100%;display: grid;background-color: @attendance-color-3}

  .popup {
    width: 311px;
    height: 500px;
    background: #ffffff;
    border-radius: 8px;
    padding: 20px;

    .close {
      z-index: 99999;
      position: absolute;
      top: 4px;
      right: 5px;
      width: 24px;
      height: 24px;
      padding: 3px;
      box-sizing: border-box;
    }
    .qz-button-group {
      .thsxxztxBtn{
        width: 100%;
        height: 44px;
        background-color: #7469F8;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC;
        font-weight: 600;
        color: #ffffff;
        position: absolute;
        left: 35px;
        bottom: 5px;
        width: 80%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/student/Score/score_replace.vue